module.exports = __webpack_public_path__ + "static/media/md-book.11d6816c.svg";